import Drawer from "components/shared/Drawer/Drawer";
import PoDisputeForm from "./PoDisputeForm";

/** Desktop wrapper: renders the shared PoDisputeForm in a right-side drawer. */
const PoDisputeDrawer = ({ items, dispute, onClose }) => {
  return (
    <Drawer title="Raise dispute" onClose={onClose} scrollable={false} overlayDisabled={dispute.submitting}>
      <PoDisputeForm variant="drawer" items={items} dispute={dispute} />
    </Drawer>
  );
};

export default PoDisputeDrawer;
